import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursCurriculum() {
  const curriculum = [{
    title: 'Vei înțelege ce sunt banii cu adevărat și vei dezlega misterul lor.',
    desc: 'Majoritatea oamenilor au o relație cu banii bazată pe frici moștenite din copilărie. Aici descoperi cum s-a format relația ta actuală și de ce funcționează așa.'
  }, {
    title: 'Vei identifica convingerile din subconștient care te sabotează financiar.',
    desc: 'Credințe precum "banii sunt răul", "nu merit mai mult" sau "banii vin greu" lucrează împotriva ta fără să îți dai seama. Le scoți la lumină și le transformi.'
  }, {
    title: 'Vei învăța cum să îți binecuvântezi banii și să ai o relație armonioasă cu ei.',
    desc: 'Banii răspund la energia pe care o pui în ei. Când îi judeci, pleacă. Când îi respecti și îi primești cu recunoștință, vin mai ușor.'
  }, {
    title: 'Vei descoperi cele șase motive reale pentru care oamenii vor bani și vei înțelege care e motivul tău.',
    desc: 'Când știi de ce vrei bani cu adevărat, direcția devine clară și energia ta se aliniază cu abundența.'
  }, {
    title: 'Vei învăța cum să îți înmulțești și să îți protejezi banii.',
    desc: 'Nu doar cum să atragi mai mult, ci și cum să păstrezi ceea ce ai. Înțelegi fluxul banilor și cum să îl menții în echilibru.'
  }, {
    title: 'Vei deveni un magnet care atrage banii.',
    desc: 'Prin exerciții practice, meditații și schimbarea mentalității, vei simți cum relația ta cu banii se transformă de la frică la încredere, de la lipsă la abundență.'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-689">
      <div className="max-w-4xl mx-auto px-6" data-id="element-690">
        <SectionHeading title="Ce vei descoperi în cursul Magnet pentru Bani" data-id="element-691" />

        <div className="space-y-5 mb-16" data-id="element-692">
          {curriculum.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="flex gap-4 items-start bg-white p-6 md:p-7 rounded-2xl shadow-sm border border-brand-text/5 hover:shadow-warm transition-shadow" data-id="element-693">
              <div className="flex-shrink-0 mt-1 w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-694">
                <CheckCircle2 className="w-6 h-6 text-brand-gold" data-id="element-695" />
              </div>
              <div data-id="element-696">
                <h3 className="font-bold text-lg text-brand-text mb-2" data-id="element-697">
                  {item.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-698">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-699">
          <CTAButton data-id="element-700" />
        </motion.div>
      </div>
    </section>;
}